package com.exura.components.layouts.nav

internal class NavigationScope(
    val isNavigationCollapsed: Boolean = false,
)
